// extracted by mini-css-extract-plugin
export default {"error":"error_error__mkhKb","head":"error_head__4SrCm"};